import { Calculator } from '@hg/stylizator/components'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

import { BANDWIDTH_SHARING_RATE } from 'app/helpers/utils'

const TOP_MENU_HEIGHT = 64

export interface IAttributes extends Omit<React.ComponentProps<typeof CalculatorBlock>, 'title'> {
  title: string
}

const CalculatorBlock: React.FC<IWPGBlock> = (props) => {
  const attributes = props.attrs as IAttributes

  return (
    <Calculator
      bandwidthSharingRate={BANDWIDTH_SHARING_RATE}
      customStickyTopOffset={TOP_MENU_HEIGHT}
      title={attributes.title}
    />
  )
}

export default CalculatorBlock
